module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAUAAAAC4AQMAAACo6KcpAAAAA1BMVEVhh6/cxCw4AAAAHklEQVRYw+3BMQEAAADCIPunNsReYAAAAAAAAAAkBx14AAGc+GVxAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./static/img/方胜磐石的经营原则背景@2x.png
// module id = FFf5
// module chunks = 0